import React, { useEffect, useState } from "react";
import { formatCurrency } from "../utils/formatCurrency";

const RentalBookingForm = ({
  t,
  userCountry,

  distanceKm,
  etaMinutes,
  fareInput,
  setFareInput,
  rideDate,
  setRideDate,
  rideTime,
  setRideTime,
  rentalPickupLocation,
  setRentalPickupLocation,
  rentalReturnLocation,
  setRentalReturnLocation,
  rentalVehicleType,
  setRentalVehicleType,
  rentalDays,
  setRentalDays,
  rentalNote,
  setRentalNote,
  handleRequestRide,
  setRideRequestVisible,
  setSelectedService,

  pickupDate,
  setPickupDate,
  pickupTime,
  setPickupTime,
  returnDate,
  setReturnDate,
  returnTime,
  setReturnTime,
  driverOption,
setDriverOption,

}) => {
  const [errors, setErrors] = useState({});
 const validateForm = () => {
  const newErrors = {};

if (!rentalPickupLocation.trim()) {
  newErrors.rentalPickupLocation = t("pickup_required");
}
  if (!rentalReturnLocation.trim()) newErrors.rentalReturnLocation = t("return_required");
if (!rentalVehicleType) newErrors.rentalVehicleType = t("select_vehicle");
if (!rentalDays || Number(rentalDays) < 1) newErrors.rentalDays = t("invalid_days");
if (!fareInput || Number(fareInput) <= 0) newErrors.fareInput = t("offer_per_day_required");

  // Pickup validation
if (!pickupDate) newErrors.pickupDate = t("pickup_date_required");
if (!pickupTime) newErrors.pickupTime = t("pickup_time_required");
if (!returnDate) newErrors.returnDate = t("return_date_required");
if (!returnTime) newErrors.returnTime = t("return_time_required");

  // 🔥 ADD THIS HERE (correct place)
  if (pickupDate && pickupTime && returnDate && returnTime) {
    const pickupDateTime = new Date(`${pickupDate}T${pickupTime}`);
    const returnDateTime = new Date(`${returnDate}T${returnTime}`);

   if (returnDateTime <= pickupDateTime) {
  newErrors.returnDate = t("return_must_be_after_pickup");
}
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

const updateRentalDays = () => {
  if (pickupDate && pickupTime && returnDate && returnTime) {
    const start = new Date(`${pickupDate}T${pickupTime}`);
    const end = new Date(`${returnDate}T${returnTime}`);
    const diff = end - start;

if (diff >= 0) {
const days = Math.max(1, Math.ceil(diff / (1000 * 60 * 60 * 24)));
setRentalDays(days);
    } else {
setRentalDays(0);      
    }
  } else {
setRentalDays(0);    
  }
};

useEffect(() => {
  updateRentalDays();
}, [pickupDate, pickupTime, returnDate, returnTime]);


  const onSubmitRental = () => {
    if (!validateForm()) return;
    handleRequestRide();
  };


  const grandTotal = Number(fareInput || 0) * Number(rentalDays || 0);

 const formatVehicle = (type) => {
  if (!type) return "-";

  const vehicleMap = {
    economy: t("vehicle_economy"),
    sedan: t("vehicle_sedan"),
    suv: t("vehicle_suv"),
    van: t("vehicle_van"),
    minibus: t("vehicle_minibus"),
    bus: t("vehicle_bus"),
    pickup: t("vehicle_pickup"),
    luxury: t("vehicle_luxury"),
    taxi: t("vehicle_taxi"),
    bike: t("vehicle_motorbike"),
    boat: t("vehicle_boat"),
    cargo_van: t("vehicle_cargo_van"),
    truck: t("vehicle_truck"),
    trailer: t("vehicle_trailer"),
    forklift: t("vehicle_forklift"),
    excavator: t("vehicle_excavator"),
    bulldozer: t("vehicle_bulldozer"),
    grader: t("vehicle_grader"),
    loader: t("vehicle_loader"),
    roller: t("vehicle_roller"),
    crane: t("vehicle_crane"),
    tractor: t("vehicle_tractor"),
    generator: t("vehicle_generator"),
    other: t("vehicle_other"),
  };

  return vehicleMap[type] || type;
};



  return (
    <div className="rental-form-wrap">
      <h4>{t("service_rental")} {t("booking")}</h4>

      <input
        className={errors.rentalPickupLocation ? "rental-error" : ""}
placeholder={t("pickup_location")}        
        value={rentalPickupLocation}
        onChange={(e) => setRentalPickupLocation(e.target.value)}
      />
      {errors.rentalPickupLocation && (
        <div className="rental-error-text">{errors.rentalPickupLocation}</div>
      )}

   {/* Pickup Date & Time */}
<input
  className={errors.pickupDate ? "rental-error" : ""}
  type="date"
  value={pickupDate}
onChange={(e) => {
  setPickupDate(e.target.value);
  if (!returnDate) setReturnDate(e.target.value);
}}
/>

<select
  className="rental-driver-option"
  value={driverOption}
  onChange={(e) => setDriverOption(e.target.value)}
>  
  <option value="">{t("Choose Driver")}</option>
<option value="With Driver">{t("With Driver")}</option>
<option value="Self Driver">{t("Self Driver")}</option>
</select>


<input
  className={errors.pickupTime ? "rental-error" : ""}
  type="time"
  value={pickupTime}
onChange={(e) => {
  setPickupTime(e.target.value);
}}
/>
{errors.pickupDate && <div className="rental-error-text">{errors.pickupDate}</div>}
{errors.pickupTime && <div className="rental-error-text">{errors.pickupTime}</div>}



      <input
        className={errors.rentalReturnLocation ? "rental-error" : ""}
placeholder={t("return_location")}        
        value={rentalReturnLocation}
        onChange={(e) => setRentalReturnLocation(e.target.value)}
      />
      {errors.rentalReturnLocation && (
        <div className="rental-error-text">{errors.rentalReturnLocation}</div>
      )}


{/* Return Date & Time */}
<input
  className={errors.returnDate ? "rental-error" : ""}
  type="date"
  value={returnDate}
  min={pickupDate}
 onChange={(e) => {
  setReturnDate(e.target.value);
}}
/>

<input
  className={errors.returnTime ? "rental-error" : ""}
  type="time"
  value={returnTime}
onChange={(e) => {
  setReturnTime(e.target.value);
}}

/>
{errors.returnDate && <div className="rental-error-text">{errors.returnDate}</div>}
{errors.returnTime && <div className="rental-error-text">{errors.returnTime}</div>}


      <select
        className={errors.rentalVehicleType ? "rental-error" : ""}
        value={rentalVehicleType}
        onChange={(e) => setRentalVehicleType(e.target.value)}
      >
<option value="">{t("select_vehicle_type")}</option>

<optgroup label={t("passenger_vehicles")}>
  <option value="economy">🚗 {t("vehicle_economy")}</option>
  <option value="sedan">🚘 {t("vehicle_sedan")}</option>
  <option value="suv">🚙 {t("vehicle_suv")}</option>
  <option value="van">🚐 {t("vehicle_van")}</option>
  <option value="minibus">🚍 {t("vehicle_minibus")}</option>
  <option value="bus">🚌 {t("vehicle_bus")}</option>
  <option value="pickup">🛻 {t("vehicle_pickup")}</option>
  <option value="luxury">💎 {t("vehicle_luxury")}</option>
  <option value="taxi">🚖 {t("vehicle_taxi")}</option>
  <option value="bike">🏍️ {t("vehicle_motorbike")}</option>
</optgroup>

<optgroup label={t("marine")}>
  <option value="boat">🚤 {t("vehicle_boat")}</option>
</optgroup>

<optgroup label={t("cargo_transport")}>
  <option value="cargo_van">📦 {t("vehicle_cargo_van")}</option>
  <option value="truck">🚛 {t("vehicle_truck")}</option>
  <option value="trailer">🚚 {t("vehicle_trailer")}</option>
</optgroup>

<optgroup label={t("machinery_equipment")}>
  <option value="forklift">🏗️ {t("vehicle_forklift")}</option>
  <option value="excavator">🚜 {t("vehicle_excavator")}</option>
  <option value="bulldozer">🚧 {t("vehicle_bulldozer")}</option>
  <option value="grader">🛣️ {t("vehicle_grader")}</option>
  <option value="loader">🏭 {t("vehicle_loader")}</option>
  <option value="roller">🛞 {t("vehicle_roller")}</option>
  <option value="crane">🏗 {t("vehicle_crane")}</option>
  <option value="tractor">🚜 {t("vehicle_tractor")}</option>
  <option value="generator">⚡ {t("vehicle_generator")}</option>
</optgroup>

<option value="other">🔧 {t("vehicle_other")}</option>
</select>

{errors.rentalVehicleType && (
  <div className="rental-error-text">{errors.rentalVehicleType}</div>
)}

      <div className="rental-two-col">
        <div>
         <input
  className="rental-readonly"
  value={rentalDays}
  readOnly
/>
          {errors.rentalDays && (
            <div className="rental-error-text">{errors.rentalDays}</div>
          )}
        </div>

        <div>
          <input
            className="rental-readonly"
            value={distanceKm}
            readOnly
            placeholder={t("distance") + " KM"}
          />
        </div>
      </div>

      {etaMinutes && (
        <div className="rental-summary-box rental-eta-box">
{t("eta")}: {etaMinutes} {t("minutes")}          
        </div>
      )}

<input
  className={`rental-fare-input ${errors.fareInput ? "rental-error" : ""}`}
  placeholder={t("offer_per_day")}
  type="number"
  value={fareInput}
  onChange={(e) => setFareInput(e.target.value)}
/>      {errors.fareInput && (
        <div className="rental-error-text">{errors.fareInput}</div>
      )}

{Number(fareInput) > 0 && Number(rentalDays) > 0 && (
          <div className="rental-live-total">
{t("total_will_be")}: {formatCurrency(grandTotal, userCountry)}          
        </div>
      )}

     

      <textarea
        className="rental-note-box"
placeholder={t("optional_rental_note")}        
        value={rentalNote}
        onChange={(e) => setRentalNote(e.target.value)}
      />

      <div className="rental-summary-box">
        <div><strong>{t("pickup")}:</strong> {rentalPickupLocation || "-"}</div>
        <div><strong>{t("return")}:</strong> {rentalReturnLocation || "-"}</div>
        <div><strong>{t("vehicle")}:</strong> {formatVehicle(rentalVehicleType)}</div>
        <div><strong>{t("days")}:</strong>{" "}
        {Number(rentalDays) > 0 ? rentalDays : "-"}
        </div>
<div>
  <strong>{t("offer_per_day_label")}:</strong>{" "}
  {fareInput ? formatCurrency(Number(fareInput), userCountry) : "-"}
</div>           
         <div>
         <strong>{t("pickup_time")}:</strong>{" "}
         {pickupDate && pickupTime ? `${pickupDate} ${pickupTime}` : "-"}
        </div>

        <div>
        <strong>{t("return_time")}:</strong>{" "}
         {returnDate && returnTime ? `${returnDate} ${returnTime}` : "-"}
        </div>
    <div className="rental-grand-total">
  <strong>{t("grand_total")}:</strong>{" "}
  {fareInput && rentalDays ? formatCurrency(grandTotal, userCountry) : "-"}
</div>

<div>
<strong>{t("Driver")}:</strong>
  {driverOption ? t(driverOption) : "-"}
</div>

</div> {/* ✅ CLOSE SUMMARY BOX */}

<button className="rental-btn rental-btn-submit" onClick={onSubmitRental}>
      {t("request_rental")}        
      </button>

      <button
        className="rental-btn rental-btn-back"
        onClick={() => setSelectedService(null)}
      >
       {t("back")}
      </button>

      <button
        className="rental-btn rental-btn-cancel"
        onClick={() => setRideRequestVisible(false)}
      >
       {t("cancel")}
      </button>
    </div>
  );
};

export default RentalBookingForm;